import { ModalDialog } from '@/Components/ModalDialog/ModalDialog';
import React from 'react';
import { useLocalization, useShowGenerateDocumentNumberDialog } from '@/Hooks';
import { useSelector } from 'react-redux';
import { documentPrintModalSelectors } from '@/ModalWindows/DocumentPrintModal/services/selectors';

type Props = {
  onClose: () => void;
};

export function CreateDocumentModal({ onClose }: Props) {
  const {
    modalWindows: {
      documentPrintModal: {
        CreateDocumentModal: { Title, Text },
      },
    },
  } = useLocalization();

  const { showGenerateDocumentNumberModal } = useShowGenerateDocumentNumberDialog();
  const documentType = useSelector(documentPrintModalSelectors.documentType);

  return (
    <ModalDialog
      title={Title}
      text={Text}
      onClose={onClose}
      onOk={() => {
        if (documentType) {
          showGenerateDocumentNumberModal(documentType);
        }
      }}
    />
  );
}
